const configuredBaseUrl = import.meta.env.VITE_API_BASE_URL?.trim();

if (!configuredBaseUrl && !import.meta.env.DEV) {
  throw new Error('VITE_API_BASE_URL must be configured for production builds.');
}

export const apiBaseUrl = configuredBaseUrl ?? 'http://localhost:5091';
